<template>
  <div class="card modal-card w-full" v-if="isLoad">
    <header class="bandeau-modal card-header">
    </header>
    <section class="card-content mgl-0 pd-40px">
      <div class="columns is-gapless is-multiline">
        <div class="column is-10">
          <h1 class="title is-size-3">
            {{ $t('detailDevis.popUpSelectFace.title',
              { reseau: demandeLogistique.libelleProduit} )}}
          </h1>
          <p class="has-text-icon-more">
            {{ $t('detailDevis.popupDuplicate.nbFace', { nbFace: getTotalSelectedFace }) }}
          </p>
          <p class="has-text-icon-more">
            {{ getDate }}
          </p>
        </div>
        <div class="column is-2 has-text-right has-text-icon-more">
            {{ $t('ajoutDevis.popUpSelectFace.nbFacesDispo',
          { totalSelect: getTotalSelectedFace,
            total: nbFaceTotal })}}
        </div>
      </div>
      <div class="pdl-0 pdr-0">
        <tab-select-faces-demande-logistique
          :listeFacesBase="listeFaces"
          :displayColumnLogistique="true"
          :isDetails=" true"
          :majInstructionPose="false"
          :inAffectation="true"
          :demandeLogistique = demandeLogistique
        />
      </div>
      <footer class="mgt-20px mgl-0">
        <b-field class="mgl-0">
          <div class="is-pulled-left boutonAction">
            <a class="button is-cancel btn-modal-annuler"
                @click="$parent.close()">
              {{ $t('detailDevis.popUpSelectFace.actions.back') }}
            </a>
          </div>
        </b-field>
      </footer>
    </section>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import tabSelectFacesDemandeLogistique from '@/components/devisCommandeFacture/facesSelectInReseauTempo/tabSelectFacesDemandeLogistique';
import { getLignesSelectionFaceForDemandeAffichage } from '@/services/dcf/reseauTempo/getListeFacesForSelection';
import messageErreur from '@/services/general/messageErreur';
import formatDate from '@/services/general/formatDate';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'p_demandeSelectionFaces',
  props: {
    demandeLogistique: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      listeFaces: null,
      isLoad: false,
    };
  },
  components: {
    tabSelectFacesDemandeLogistique,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    getTotalSelectedFace() {
      return this.listeFaces?.filter(f => f.selected).length;
    },
    nbFaceTotal() {
      return this.listeFaces?.length;
    },
    getDate() {
      return this.$i18n.t('detailDevis.popUpSelectFace.dateJour', {
        dateDebut: formatDate(this.demandeLogistique.datePlanification),
      });
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    async initSelFaces() {
      if (this.listeFaces) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametreUtilisateur();
        const users = this.parametre(PARAMETRES_KEYS.utilisateur);
        const liste = await getLignesSelectionFaceForDemandeAffichage(this.demandeLogistique,
          users, this.societeActiveId,
          this.demandeLogistique.datePlanification);
        liste.forEach(produit => {
          produit.selected = this.demandeLogistique
            .demandeLogistiqueSelProduit.some(sel => sel.produitId === produit.produitId);
        });
        liste.sort((a, b) => a.affecteLogistiquement - b.affecteLogistiquement);
        this.listeFaces = liste;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    await this.initSelFaces();
    this.isLoad = true;
  },
};
</script>
